// 装備一覧のアイコン配列
export const MAX_PAGE = 99;
export const COLS_PER_PAGE_IN_EQLIST = 10;
export const ROWS_PER_PAGE_IN_EQLIST = 5;
export const MAX_PAGE_IN_RINNE = 99;
export const COLS_PER_PAGE_IN_RINNE = 8;
export const ROWS_PER_PAGE_IN_RINNE = 4;
// スキル
export const MAX_SKILL_LEVEL = 7;
// 護石
export const MAX_RARITY = 10;
export const MAX_NUM_SKILLS = 2;
export const MAX_NUM_SLOTS = 3;
export const MAX_SLOT_LEVEL = 4;
